module.exports = __webpack_public_path__ + "static/UP-8fc351daaa782b7b4762cc30eb666d86.mp4";